import { Component, Input, Output, OnInit, EventEmitter } from '@angular/core';
import { CurationAgentActionModel } from 'app/AutomationAgents/models/curation-agent-action.model';
import { folderActionTypes, tagActionTypes } from '../../enums/curation-agent-action-type.enum';

@Component({
    selector: 'agpr-action-chip',
    templateUrl: './action-chip.component.html',
    styleUrl: './action-chip.component.scss',
    standalone: false
})
export class ActionChipComponent implements OnInit {

    @Input() id: string;
    @Input() action: CurationAgentActionModel;

    /** Emits the id of the target that was clicked - an action can list several */
    @Output() viewActionTarget: EventEmitter<string> = new EventEmitter<string>();

    canViewActionTarget: boolean = false;

    ngOnInit(): void {
        this.canViewActionTarget = !!this.action.referenceIds.length
            && (folderActionTypes.includes(this.action.type) || tagActionTypes.includes(this.action.type));
    }
}
